import { Button, toast } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { CatalogProductCreateInput } from "@/modules/catalog/domain/contracts";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateCatalogProduct } from "../api/queries";
import { CatalogProductForm } from "../ui/CatalogProductForm";

export function CatalogProductCreatePage() {
  const nav = useNavigate({ from: "/app/catalog/create" });
  const createProduct = useCreateCatalogProduct();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Catalog", to: "/app/catalog" },
            { label: "ເພີ່ມສິນຄ້າ" },
          ]}
        />
      </Header>
      <Main>
        <div className="mx-auto max-w-5xl">
          <div className="mb-4 flex flex-wrap items-center justify-between gap-4">
            <div>
              <h1 className="font-bold text-2xl tracking-tight">ເພີ່ມສິນຄ້າ</h1>
              <p className="text-muted-foreground text-sm">
                ສ້າງສິນຄ້າຫຼັກໃໝ່ໃນ Catalog (ບໍ່ມີ shop_id)
              </p>
            </div>
            <Button
              variant="outline"
              onClick={() => nav({ to: "/app/catalog" })}
            >
              <ArrowLeftIcon className="size-4" aria-hidden />
              ກັບຄືນ
            </Button>
          </div>

          <CatalogProductForm
            onSubmit={async (vals) => {
              try {
                await createProduct.mutateAsync(
                  vals as CatalogProductCreateInput,
                );
                toast.success("ເພີ່ມສິນຄ້າສຳເລັດ");
                nav({ to: "/app/catalog" });
              } catch {
                toast.error("ເພີ່ມລົ້ມເຫຼວ");
              }
            }}
            onCancel={() => nav({ to: "/app/catalog" })}
            submitting={createProduct.isPending}
            submitLabel="ບັນທຶກ"
          />
        </div>
      </Main>
    </>
  );
}
